import { PureLightTheme } from "../../../../styles/theme"

export const CardItem = {
  maxWidth: '736px',
  width: '100%',
  padding: '20px',
  cursor: 'pointer',
}

export const CardImg = {
  height: '120px',
  width: '120px',
  minWidth: '120px',
  minHeight: '120px',
  flexShrink: 0,
  objectFit: 'cover',
  borderRadius: '8px',
}

export const TypDescription = {
  display: '-webkit-box',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 3,
  '@media (max-width:1200px)': {
    WebkitLineClamp: 2,
  },
  [PureLightTheme.breakpoints.down('sm')]: {
    mb: 1,
  },
  '@media (max-width:400px)': {
    WebkitLineClamp: 3,
  },
}
